import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation, forwardRef, input, output } from "@angular/core";
import { Wrapper } from "../wrapper.interface";
import { ButtonConfig, IconPosition } from "./button.config";
import { ButtonModule } from "primeng/button";
import { CommonModule } from "@angular/common";
import { WRAPPER_TOKEN } from "../wrapper.tokens";
import { FaPrefix } from 'src/app/components/v-icon/types';
import { TranslateModule } from "@ngx-translate/core";
import { VIconComponent } from "src/app/components/v-icon/v-icon.component";

@Component({
    selector:        'v-button',
    templateUrl:     './button.component.haml',
    styleUrls:       ['./button.component.sass', '../style.sass'],
    encapsulation:   ViewEncapsulation.None,
    providers:       [{ provide: WRAPPER_TOKEN, useExisting: forwardRef(() => VButtonComponent) }],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone:      true,
    imports:         [ButtonModule, VIconComponent, CommonModule, TranslateModule]
})
export class VButtonComponent extends Wrapper<ButtonConfig>{
    protected _baseConfig: ButtonConfig = ButtonConfig.baseTheme.Default;
    public onClick = output<MouseEvent>();
    public onFocus = output<FocusEvent>();
    public onBlur = output<FocusEvent>();

    public ariaLabel = input(undefined, {alias: "aria-label"});
    public iconPosition = input<IconPosition>();
    public icon = input<string>();
    public labelInput = input<string>(undefined, {alias: "label"});
    public href = input<string>(undefined);
    public prefix = input<FaPrefix>("fas");
    public buttonType = input<string>(undefined, {alias: "type"});

    @HostBinding("class.v-button-icon") private get isIconStyle() {
        return this.config()?.style === "icon";
    }
    @HostBinding("class.v-button-wide") private get isWide() {
        return (this.buttonType() ?? this.config()?.type) === "wide";
    }
    @HostBinding("class.v-button-icon-reverse") private get isIconPositionRight() {
        return (this.iconPosition() ?? this.config().iconPosition) === "right";
    }
    @HostBinding("class.v-button-full") private get isFull() {
        return (this.buttonType() ?? this.config()?.type) === "full";
    }

    @HostBinding("class.v-href") private get isHref() {
        return ![null, undefined].includes(this.href());
    }
}